<template>
    <DFormRow
        :label="__('customers.contracts.invoice_text')"
        :is-required="false"
        :error="errors.invoice_text"
    >
        <DFormTextarea
            id="invoice_text"
            rows="5"
            :model-value="modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
const emit = defineEmits('update:modelValue')

defineProps({
    modelValue: {
        type: [String],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

</script>
